/* eslint-disable no-unused-vars */
/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable consistent-return */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import firebase from 'firebase/app';
import { useSnackbar } from 'notistack';
import { firebaseErrors } from 'services/api/firebaseErrors';
import { Title, Text } from 'components/Text';
import { Button } from 'components/Button';
import { LabelInputMask } from 'components/InputMask';
import { ALERT_TYPE } from 'components/Alert';
import SnackMessage, { OPTIONS } from 'components/SnackMessage';
import {
  updateCustomer,
} from 'services/api/customers';
import {
  Container, BoxButtons,
} from './styles';

// Estrutura para mudar o número do celular
const ChangePhoneNumber = ({
  currentUser, user, updateUser, recoverPhoneModal, currentNumber, setCurrentNumber, newNumber, setNewNumber, setVerificationId, reset,
}) => {
  const [disabled, setDisabled] = useState(true);
  const [loading, setLoading] = useState(false);

  const formatNumber = (number) => (number && number.replaceAll(' ', '').replace('(', '').replace(')', '').replace('-', '')
    .replaceAll('_', ''));

  const { enqueueSnackbar } = useSnackbar();

  // Reseta container do reCAPTCHA
  const resetRecaptcha = () => window.recaptchaVerifier.reset();

  const verifyCode = async (e) => {
    e.preventDefault();
    setLoading(true);
    const payload = {
      ...user,
      cel_phone: formatNumber(newNumber),
    };

    try {
      await updateCustomer(user.id, payload);
      enqueueSnackbar('Celular adicionado com sucesso!', {
        ...OPTIONS,
        content: (key, message) => (
          <SnackMessage
            id={key}
            message={message}
            variant={ALERT_TYPE.SUCCESS}
          />
        ),
      });
    } catch (error) {
      enqueueSnackbar('Erro ao adicionar celular.', {
        ...OPTIONS,
        content: (key, message) => (
          <SnackMessage
            id={key}
            message={message}
            variant={ALERT_TYPE.ERROR}
          />
        ),
      });
    } finally {
      setLoading(false);
      setNewNumber('');
    }

    // if (currentUser.phoneNumber) {
    //   const currentNumberFormat = formatNumber(currentNumber);
    //   if (currentUser.phoneNumber !== currentNumberFormat) {
    //     enqueueSnackbar('Número digitado atual inválido.', {
    //       ...OPTIONS,
    //       content: (key, message) => (
    //         <SnackMessage
    //           id={key}
    //           message={message}
    //           variant={ALERT_TYPE.ERROR}
    //         />
    //       ),
    //     });
    //     return false;
    //   }
    // }

    // const appVerifier = window.recaptchaVerifier;

    // const provider = new firebase.auth.PhoneAuthProvider();
    // await provider.verifyPhoneNumber(newNumber, appVerifier)
    //   .then(async (verificationId) => {
    //     setVerificationId(verificationId);
    //     recoverPhoneModal(true);
    //     updateUser({
    //       ...user,
    //       cel_phone: formatNumber(newNumber),
    //       full_name: user.full_name || currentUser.displayName,
    //     });
    //   }).catch((error) => {
    //     if (error.code) {
    //       enqueueSnackbar(firebaseErrors[error.code], {
    //         ...OPTIONS,
    //         content: (key, message) => (
    //           <SnackMessage
    //             id={key}
    //             message={message}
    //             variant={ALERT_TYPE.ERROR}
    //           />
    //         ),
    //       });
    //     }
    //     resetRecaptcha();
    //   });
  };

  // const validateFields = () => {
  //   if (currentUser.phoneNumber) {
  //     if (formatNumber(currentNumber).length === 14
  //       && formatNumber(newNumber).length === 14) {
  //       setDisabled(false);
  //     } else {
  //       setDisabled(true);
  //     }
  //   } else if (formatNumber(newNumber).length === 14) {
  //     setDisabled(false);
  //   } else {
  //     setDisabled(true);
  //   }
  // };

  const validateFields = () => {
    if (formatNumber(newNumber).length === 14) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  };

  useEffect(() => {
    validateFields();
  }, [currentNumber, newNumber]);

  return (
    <Container>
      <Title secondary>
        Segurança
      </Title>
      <Text>
        {/* {
          currentUser.phoneNumber ? 'Para alterar seu número de celular cadastrado, confirme o atual e digite o novo número de celular' : 'Adicione o seu número de celular para podemos enviar notificações por SMS quando necessário.'
        } */}
        Adicione o seu número de celular para podemos enviar notificações por SMS quando necessário.
      </Text>
      <form onSubmit={verifyCode}>
        {/* {
          !currentUser.phoneNumber && (
            <LabelInputMask
              name="currentNumber"
              type="tel"
              mask="+55 (99) 9 9999-9999"
              placeholder="Digite o número de celular atual"
              label="Digite o número de celular atual"
              value={currentNumber}
              onChange={(e) => setCurrentNumber(e.target.value)}
              title="Insira o seu número de celular"
              style={{
                width: '100%',
                margin: '24px 0 0 0',
              }}
            />
          )
        } */}
        <LabelInputMask
          name="newNumber"
          type="tel"
          mask="+55 (99) 9 9999-9999"
          // label={
          //   !currentUser.phoneNumber
          //     ? 'Digite o novo número de celular'
          //     : 'Digite o seu número de celular'
          // }
          label="Digite o seu número de celular"
          value={newNumber}
          onChange={(e) => setNewNumber(e.target.value)}
          title="Insira o seu número de celular"
          style={{
            width: '100%',
            margin: '10px 0 0 0',
          }}
        />
        <BoxButtons>
          <Button onClick={verifyCode} type="submit" disabled={disabled} loading={loading}>
            {/* {currentUser.phoneNumber ? 'Confirmar alteração' : 'Adicionar número'} */}
            Adicionar número
          </Button>
          <Button
            onClick={reset}
            variant="outlined"
          >
            Voltar a tela inicial
          </Button>
        </BoxButtons>
      </form>
    </Container>
  );
};

ChangePhoneNumber.propTypes = {
  currentNumber: PropTypes.string.isRequired,
  setCurrentNumber: PropTypes.func.isRequired,
  newNumber: PropTypes.string.isRequired,
  setNewNumber: PropTypes.func.isRequired,
  setVerificationId: PropTypes.func.isRequired,
  currentUser: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  updateUser: PropTypes.func.isRequired,
  recoverPhoneModal: PropTypes.func.isRequired,
  reset: PropTypes.func,
};

export default ChangePhoneNumber;
